module.exports = __webpack_public_path__ + "static/img/bg-es.bbd79855.webp";